<template>
  <div
    class="home"
    :style="{ 'background-image': 'url(\'' + background + '\')' }"
  >
    <div class="left-container">
      <div class="left-layout">
        <div class="content">
          <h1>GET Portal</h1>
          <div class="underline"></div>
          <br>
          <h2>
            Møtestedet for utviklere og bedrifter med behov for IT-kompetanse
          </h2>
          <div class="btns">
            <div class="btn">
              <PrimaryButton text="For student" privilige="student" @click="login" />
            </div>
            <!-- <div class="btn">
              <PrimaryButton
                text="For bedrift"
                privilige="company"
                style="
                  background-color: white;
                  color: hotpink;
                  border: 1px solid hotpink;
                "
              />
            </div> -->
          </div>
        </div>
      </div>
    </div>

    <div class="right-container"></div>
  </div>
</template>

<script>
export default {
  name: "Home",
  data() {
    return {
      background: require("@/assets/frontpage-background.jpg"),
    };
  },
  mounted() {
    [...document.getElementsByTagName("main")].map(
      (elem) => (elem.style.maxWidth = "100%")
    );
  },
};
</script>

<style scoped lang="scss">
.home {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: stretch;
  background-size: cover;
  min-height: 850px;
}

.left-container {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-grow: 1;
  background-color: rgba(255, 255, 255, 0.75);
}

.left-layout {
  // float: right;
  // display: flex;
  max-width: 500px;
  width: var(--content-width);
  margin: auto;

  .content {
    // margin: 0 auto 200px;
  }
}
.right-container {
  flex-basis: 0;
  flex-grow: 6;
}

.btns {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.btn {
  // margin: auto;
  padding: 30px 0;
}
.underline {
  /* Rectangle 110 */
position: absolute;
width: 60px;
height: 5px;
background: #EE7100;
border-radius: 7px;
}
@media only screen and (max-width: 768px) {
  .left-container {
    width: 100%;
    padding: 2em;
  }
}
</style>